import { SitemapVersionLevel } from "@iventis/domain-model/model/sitemapVersionLevel";
import { SitemapVersionLevelCadConfig } from "@iventis/domain-model/model/sitemapVersionLevelCadConfig";
import { SitemapVersionLevelUploadMethod } from "@iventis/domain-model/model/sitemapVersionLevelUploadMethod";
import { SitemapVersionLevelWithFiles } from "@iventis/sitemaps/src/sitemap-types";
import { readFileAsJson } from "@iventis/utilities";

interface SitemapVerisonLevelPatchRequest {
    id: SitemapVersionLevel["id"];
    perimeter?: SitemapVersionLevel["perimeter"];
    levelIndex?: SitemapVersionLevel["levelIndex"];
    levelName?: SitemapVersionLevel["levelName"];
    levelAbbreviation?: SitemapVersionLevel["levelAbbreviation"];
    bounding?: SitemapVersionLevel["bounding"];
    status?: SitemapVersionLevel["status"];
    cadConfig?: SitemapVersionLevelCadConfig;
    style?: Object;
    uploadMethod?: SitemapVersionLevelUploadMethod;
}

/** Creates a patch reqeust body for sitemap version level, removing any values which are null */
export async function createSitemapVersionLevelPatchRequestBody(sitemapVersionLevel: SitemapVersionLevelWithFiles): Promise<SitemapVerisonLevelPatchRequest> {
    const requestBody: SitemapVerisonLevelPatchRequest = {
        id: sitemapVersionLevel.id,
    };

    if (sitemapVersionLevel.uploadMethod === SitemapVersionLevelUploadMethod.Mbtiles && sitemapVersionLevel.style != null) {
        requestBody.style = await readFileAsJson(sitemapVersionLevel.style);
    }

    if (sitemapVersionLevel.uploadMethod != null) {
        requestBody.uploadMethod = sitemapVersionLevel.uploadMethod;
    }

    if (sitemapVersionLevel.perimeter != null) {
        requestBody.perimeter = JSON.parse(sitemapVersionLevel.perimeter);
    }

    if (sitemapVersionLevel.bounding != null) {
        requestBody.bounding = sitemapVersionLevel.bounding;
    }

    if (sitemapVersionLevel.levelIndex != null) {
        requestBody.levelIndex = sitemapVersionLevel.levelIndex;
    }

    if (sitemapVersionLevel.levelName != null) {
        requestBody.levelName = sitemapVersionLevel.levelName;
    }

    if (sitemapVersionLevel.levelAbbreviation != null) {
        requestBody.levelAbbreviation = sitemapVersionLevel.levelAbbreviation;
    }

    if (sitemapVersionLevel.status != null) {
        requestBody.status = sitemapVersionLevel.status;
    }

    if (sitemapVersionLevel.uploadMethod === SitemapVersionLevelUploadMethod.Cad && sitemapVersionLevel.cadConfig) {
        requestBody.cadConfig = sitemapVersionLevel.cadConfig;
    }

    return requestBody;
}
